export default __webpack_public_path__ + "static/media/photo--sm--82.cbeb95f4.jpg";